import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="coloriser"
export default class extends Controller {
  static values = { color: String };

  declare readonly colorValue: string;
  declare readonly hasColorValue: boolean;

  connect() {
    if (this.hasColorValue) {
      const element = this.element as HTMLElement;
      element.style.borderLeftWidth = "5px";
      element.style.borderLeftStyle = "solid";
      element.style.borderLeftColor = this.colorValue;
      element.style.paddingLeft = "10px";
    }
  }
}
